import { ref,watch } from '@vue/composition-api'
import { ReportService } from '@/app/reports/share/report.service'
import  ReportOptions from  '@/views/reports/components/options.js'

const  {defaultFromdate,defaultTodate} =ReportOptions()

export default function ContainerReportLogic() {

  const request = ref({
    page: 1,
    length: 25,
    type: 'containerPlan',
   // inside: true,
    from: defaultFromdate,
    to: defaultTodate,
    plan_type: [],
    plans: [],

    //dependsOn_duration_operator:"",
  })

  const report_data = ref(null)

  const from = ref(0)
  const to = ref(0)
  const total = ref(0)

  const errors = ref({})
  const loading = ref(false)

  const sortBy = ref('id')
  const isSortDirDesc = ref(true)
  
  
  watch([sortBy,isSortDirDesc],()=>{
  
    request.value.sortBy=  isSortDirDesc.value==true? sortBy.value+',desc':sortBy.value+',asc';
    getReport()
  })
  const getReport = () => {

    errors.value = {}
    loading.value = true
   
    ReportService.getReport(request.value)
    
      .then(res => {
        report_data.value = res.data.data
        from.value = res.data.from
        to.value = res.data.to
        total.value = res.data.total
      })
      .catch(reason => reason.status === 422 ? errors.value = reason.data.errors : {})
      .finally(() =>  loading.value = false)
  }



  const getReportForPdf = () => {
    loading.value = true
    return new Promise((r, j) => {
      ReportService.getReport({ ...Object.assign(request.value, {
        page:1
      }), length: 50000}).then(res => r(res.data.data))
        .finally(() =>  loading.value = false)
    })
  }


  return {
    getReport,getReportForPdf,
    report_data,
    total, from, to,
    request,
    loading,
    errors,
    sortBy,
    isSortDirDesc
  }
}
